export enum IdValidationStatus {
    "Valid" = "valid",
    "Invalid" = "invalid",
    "Error" = "error"
}
